import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './createCourse.module.css';
import Header from '../../components/standartComponents/header';

const TOPICS = [
  { id: 'work', name: 'Робота', en: 'Work English', desc: 'Співбесіди, зустрічі, листування, робочі діалоги.', icon: '💼', bg: '#EEF0FF' },
  { id: 'travel', name: 'Подорожі', en: 'Travel English', desc: 'Аеропорт, готель, кафе, знайомства за кордоном.', icon: '✈️', bg: '#FEF3C7' },
  { id: 'study', name: 'Навчання', en: 'Study English', desc: 'Освітні теми, пояснення, академічна лексика.', icon: '🎓', bg: '#E0E3FF' },
  { id: 'social', name: 'Спілкування', en: 'Social English', desc: 'Small talk, знайомства, щоденні розмови.', icon: '💬', bg: '#ECFDF5' },
  { id: 'personal', name: 'Для себе', en: 'Personal English', desc: 'Теми з життя, хобі та легка практика.', icon: '🌿', bg: '#FFF1F2' },
  { id: 'tech', name: 'News & Tech', en: 'Tech English', desc: 'Сучасні теми, технології, новини та обговорення.', icon: '📱', bg: '#F0F9FF' },
  { id: 'health', name: 'Здоров\'я', en: 'Health English', desc: 'Лікар, самопочуття, аптека, базові ситуації.', icon: '🩺', bg: '#ECFDF5' },
  { id: 'leisure', name: 'Дозвілля', en: 'Leisure English', desc: 'Плани, вихідні, розваги та зустрічі.', icon: '🎯', bg: '#FFFBEB' }
];

const LEVELS = [
  { id: 'A0', name: 'A0', desc: 'Починаю з нуля' },
  { id: 'A1', name: 'A1', desc: 'Знаю базові слова і прості фрази', rec: true },
  { id: 'A2', name: 'A2', desc: 'Розумію прості діалоги' },
  { id: 'B1', name: 'B1', desc: 'Можу говорити на знайомі теми' },
  { id: 'B2', name: 'B2', desc: 'Вільно спілкуюся у більшості ситуацій' },
  { id: 'C1', name: 'C1', desc: 'Говорю впевнено на складні теми' }
];

const NEXT_LEVEL = { A0: 'A1', A1: 'A2', A2: 'B1', B1: 'B2', B2: 'C1', C1: 'C2' };

const CreateCourse = ({ authUser }) => {
  const navigate = useNavigate();
  
  const [selTopic, setSelTopic] = useState(null);
  const [selLevel, setSelLevel] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const topicObj = TOPICS.find(t => t.id === selTopic);
  const nextLvl = selLevel ? (NEXT_LEVEL[selLevel] || 'C2') : '';

  const handleCreate = () => {
    if (!selTopic || !selLevel) return;
    setIsSuccess(true);
    // Real implementation would involve an API call here to save the new course
  };

  return (
    <>
      <Header authUser={authUser} />

      <div className={classes.page}>
        
        {!isSuccess ? (
          <div id="mainFlow">
            <div className={classes.pgT}>Що нового будемо вчити? 🎯</div>
            <div className={classes.pgS}>Оберіть тему та рівень для нового курсу. Завершені курси залишаться у вашому кабінеті.</div>

            {/* TOPICS */}
            <div className={classes.sec}>
              <div className={classes.secT}>Яку тему хочете вивчати?</div>
              <div className={classes.secS}>Ми підберемо уроки під новий напрям навчання.</div>
              <div className={classes.tgrid}>
                {TOPICS.map(t => (
                  <div 
                    key={t.id} 
                    className={`${classes.tc} ${selTopic === t.id ? classes.tcSel : ''}`} 
                    onClick={() => setSelTopic(t.id)}
                  >
                    <div className={classes.tcCheck}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                    </div>
                    <div className={classes.tcIco} style={{ background: t.bg }}>{t.icon}</div>
                    <div className={classes.tcName}>{t.name}</div>
                    <div className={classes.tcDesc}>{t.desc}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* LEVELS */}
            <div className={classes.sec}>
              <div className={classes.secT}>З якого рівня почати цей курс?</div>
              <div className={classes.secS}>Ми рекомендуємо <strong>A1</strong> на основі Travel English A0 → A1. Для іншої теми ви можете змінити рівень.</div>
              <div className={classes.lvls}>
                {LEVELS.map(l => (
                  <div 
                    key={l.id} 
                    className={`${classes.lv} ${selLevel === l.id ? classes.lvSel : ''}`}
                    onClick={() => setSelLevel(l.id)}
                  >
                    <div className={classes.lvBadge}>{l.name}</div>
                    <div className={classes.lvInfo}>
                      <span className={classes.lvName}>{l.desc}</span>
                      {l.rec && <span className={classes.lvRec}>★ рекомендовано</span>}
                    </div>
                    <div className={classes.lvRadio}></div>
                  </div>
                ))}
              </div>
              <div className={classes.lvHelp}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                Не впевнені? Оберіть приблизний рівень — його можна змінити пізніше в налаштуваннях курсу.
              </div>
            </div>

            {/* SUMMARY */}
            <div className={`${classes.sum} ${selTopic && selLevel ? classes.sumSh : ''}`}>
              <div className={classes.sumT}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
                Новий курс
              </div>
              <div className={classes.sumGrid}>
                <div className={classes.sumItem}><div className={classes.sumLabel}>Тема</div><div className={classes.sumVal}>{topicObj?.en || '—'}</div></div>
                <div className={classes.sumItem}><div className={classes.sumLabel}>Стартовий рівень</div><div className={classes.sumVal}>{selLevel || '—'}</div></div>
                <div className={classes.sumItem}><div className={classes.sumLabel}>План</div><div className={classes.sumVal}>{selLevel ? `${selLevel} → ${nextLvl}` : '—'}</div></div>
                <div className={classes.sumItem}><div className={classes.sumLabel}>Орієнтовно</div><div className={classes.sumVal}>18 уроків</div></div>
              </div>
              <div className={classes.sumNote}>Курс буде додано до «Мої курси». Завершений Travel English A0 → A1 залишиться доступним.</div>
            </div>

            {/* ACTIONS */}
            <div className={classes.acts}>
              <button className={`${classes.btn} ${classes.btnS}`} onClick={() => window.history.back()}>Скасувати</button>
              <button className={`${classes.btn} ${classes.btnP} ${(!selTopic || !selLevel) ? classes.dis : ''}`} onClick={handleCreate}>
                Створити курс 
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
            </div>
          </div>
        ) : (
          /* SUCCESS */
          <div className={`${classes.success} ${classes.successSh}`}>
            <div className={classes.sIco}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <div className={classes.sH}>Курс створено!</div>
            <div className={classes.sP}>{topicObj?.en} {selLevel} → {nextLvl} додано до ваших курсів.</div>
            <div className={classes.sBtns}>
              <button className={`${classes.btn} ${classes.btnP}`} onClick={() => navigate('/roadMap')}>
                Перейти до плану <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
              <button className={`${classes.btn} ${classes.btnS}`} onClick={() => navigate('/mylearning')}>
                Повернутися в Моє навчання
              </button>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default CreateCourse;
